import ZodConfig from 'constants/zodConfig'
import {z} from 'zod'

const structure = {
    name: 'structure',
    type: 'autocomplete',
    label: 'structure',
    rules: {required: true},
    sm: 6,
    xs: 12,
}
const meter = {
    name: 'meter',
    type: 'autocomplete',
    label: 'meter',
    rules: {required: true},
    sm: 6,
    xs: 12,
}

const date = {
    name: 'date',
    rules: {required: true},
    type: 'datepicker',
    sm: 6,
    xs: 12,
}

const value = {
    name: 'value',
    rules: {required: true},
    sm: 6,
    xs: 12,
}

const is_new_meter = {
    name: 'is_new_meter',
    type: 'switch',
    label: 'is_new_meter',
    sm: 12,
    xs: 12,
}

export const createMeterReadingField = {
    createMeterReading: {
        title: 'createMeterReading',
        items: {
            structure,
            meter,
            date,
            value,
            is_new_meter,
        },
    },
}

export const editMeterReadingField = {
    editMeterReading: {
        title: 'editMeterReading',
        items: {
            structure: {...structure, readOnly: true},
            meter: {...meter, readOnly: true},
            date,
            value,
            is_new_meter,
        },
    },
}

export const createMeterReadingFieldValidation = z.object({
    structure: ZodConfig.stringDocument(),
    meter: ZodConfig.stringDocument(),
    date: ZodConfig.date(),
    value: ZodConfig.number({min: 0}),
    is_new_meter: z.boolean().optional(),
})
